import { Link } from 'react-router-dom';
import { MaterialIcon } from './MaterialIcon';

export function Footer() {
  return (
    <footer className="bg-surface-container-lowest border-t border-white/10 py-16 px-margin-mobile md:px-margin-desktop">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-stack-lg">
        <div className="text-center md:text-left">
          <div className="font-headline-md-mobile text-headline-md-mobile font-black text-primary italic tracking-tighter mb-2">
            Deck After Dark
          </div>
          <p className="text-on-surface-variant text-label-sm">© 2026 Nocturnal Labs. All rights reserved.</p>
        </div>
        <div className="flex gap-stack-lg">
          <a
            className="font-label-bold text-label-bold text-on-surface-variant hover:text-primary transition-colors"
            href="#how-it-works"
          >
            Rules
          </a>
          <Link
            className="font-label-bold text-label-bold text-on-surface-variant hover:text-primary transition-colors"
            to="/how-to-play"
          >
            How to Play
          </Link>
          <a
            className="font-label-bold text-label-bold text-on-surface-variant hover:text-primary transition-colors"
            href="/CREDITS.md"
          >
            Credits
          </a>
          <a
            className="font-label-bold text-label-bold text-on-surface-variant hover:text-primary transition-colors"
            href="#"
          >
            Privacy
          </a>
        </div>
        <div className="flex gap-4">
          <button
            type="button"
            className="w-10 h-10 rounded-full bg-surface-container-high flex items-center justify-center hover:bg-surface-variant transition-colors"
            aria-label="Website"
          >
            <MaterialIcon name="public" className="text-[20px]" />
          </button>
          <button
            type="button"
            className="w-10 h-10 rounded-full bg-surface-container-high flex items-center justify-center hover:bg-surface-variant transition-colors"
            aria-label="Chat"
          >
            <MaterialIcon name="chat" className="text-[20px]" />
          </button>
        </div>
      </div>
    </footer>
  );
}
